/* eslint-disable import/no-duplicates */
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// ------ same icon different styles ------//
import { faBookmark as fasBookmark } from '@fortawesome/pro-solid-svg-icons';
import { faBookmark as falBookmark } from '@fortawesome/pro-light-svg-icons';

// ------ PRO - SOLID icons  ------//
// PREFIX : 'fas'
// Example :  <font-awesome-icon :icon="['fas', 'minus-square']" />
import { faPlane,
  faCarSide,
  faBars,
  faGrid,
  faTriangleExclamation,
  faSpinner,
  faXmark,
  faHourglass,
  faArrowRightFromBracket,
} from '@fortawesome/pro-solid-svg-icons';

// ------ PRO - Light icons  ------//
// PREFIX : 'fal'
// Example :  <font-awesome-icon :icon="['fal', 'minus-square']" />
import {
  faPlusSquare,
  faMinusSquare,
  faCheck,
  faGlobe,
  faWindowClose,
  faTimesCircle,
  faMapMarkerAlt,
  faEdit,
  faShoppingBag,
  faCarBus,
  faFileCircleXmark,
  faFileArrowDown,
  faDownload,
  faFolderImage,
} from '@fortawesome/pro-light-svg-icons';

// ------ FREE - Solid icons  ------//
// PREFIX : 'fas'
// Example :  <font-awesome-icon :icon="['fas', 'minus-square']" />
import {
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCaretDown,
  faEnvelope,
  faClock,
  faPhone,
  faBriefcase,
  faTimes,
  faUndo,
  faUndoAlt,
  faPlus,
  faMinus,
  faUser,
  faBed,
  faBath,
  faMoon,
  faExclamationCircle,
  faCalendarCheck,
  faPencilAlt,
  faTicketAlt,
  faFile,
  faPassport,
  faShoppingCart,
  faTrashAlt,
  faArrowRight,
  faArrowLeft,
  faMap,
  faSlidersH,
  faCheckCircle,
  faCircle,
  faEllipsisV,
  faTruck,
  faCommentDots,
  faShareAlt,
  faEye,
  faEyeSlash,
  faInfoCircle,
  faExpand,
  faSearch,
  faTag,
  faTags,
  faMousePointer,
  faUserFriends,
  faQuestionCircle,
  faReply,
  faStar,
  faTaxi,
  faFerry,
  faHourglassStart,
  faBuildingColumns,
  faCreditCard,
  faChevronCircleRight,
  faLocationDot,
  faChevronLeft,
  faChevronDown,
  faChevronRight,
  faMagnifyingGlass
} from "@fortawesome/free-solid-svg-icons";

// ------ FREE - Brand SVG icons  ------//
// PREFIX : 'fab'
// Example :  <font-awesome-icon :icon="['fab', 'facebook']" />
import {
  faTwitter,
  faInstagram,
  faYoutube,
  faSpotify,
  faWhatsapp,
  faFacebook,
  faFacebookF,
  faFacebookMessenger,
  faFacebookSquare,
  faGoogle,
  faApple,

} from '@fortawesome/free-brands-svg-icons';

library.add(
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCaretDown,
  faEnvelope,
  faClock,
  faPhone,
  faBriefcase,
  faTimes,
  faMapMarkerAlt,
  faUndo,
  faUndoAlt,
  faPlus,
  faMinus,
  faUser,
  faBed,
  faBath,
  faMoon,
  faExclamationCircle,
  faCalendarCheck,
  faPencilAlt,
  faTicketAlt,
  faFile,
  faStar,
  faPassport,
  faShoppingCart,
  faTrashAlt,
  faArrowRight,
  faArrowLeft,
  faMap,
  faSlidersH,
  faCheckCircle,
  faCircle,
  faTruck,
  faEllipsisV,
  faCommentDots,
  faShareAlt,
  faEye,
  faEyeSlash,
  faInfoCircle,
  faExpand,
  faSearch,
  faPlusSquare,
  faMinusSquare,
  faCheck,
  faGlobe,
  faTag,
  faTags,
  faWindowClose,
  faMousePointer,
  faUserFriends,
  faQuestionCircle,
  faReply,
  faTimesCircle,
  faEdit,
  faShoppingBag,
  faPlane,
  faTaxi,
  faFerry,
  fasBookmark,
  falBookmark,
  faArrowRightFromBracket,
  faBars,
  faGrid,
  faTriangleExclamation,
  faFolderImage,
  faXmark,
  faHourglassStart,
  faCarSide,
  faCarBus,
  faBuildingColumns,
  faCreditCard,
  faSpinner,
  faChevronCircleRight,
  faLocationDot,
  faHourglass,
  faFileCircleXmark,
  faChevronLeft,
  faChevronDown,
  faChevronRight,
  faMagnifyingGlass,
  faFileArrowDown,
  faDownload
);

// BRANDS
library.add(
  faTwitter,
  faInstagram,
  faYoutube,
  faSpotify,
  faWhatsapp,
  faFacebook,
  faFacebookF,
  faFacebookMessenger,
  faFacebookSquare,
  faGoogle,
  faApple,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// ------------------NOTES-------------------------//

// Style		    font-face weight
//---------------------------------------
// Solid	        900
// Regular	        400
// Light	        300
// Duotone	        900
// Brands	        400

// TO REMOVE OR ADD PACKAGES
// npm i --save @fortawesome/free-solid-svg-icons
// npm i --save @fortawesome/free-regular-svg-icons
// npm i --save @fortawesome/free-brands-svg-icons
// npm i --save @fortawesome/pro-solid-svg-icons
// npm i --save @fortawesome/pro-regular-svg-icons
// npm i --save @fortawesome/pro-light-svg-icons
// npm i --save @fortawesome/pro-thin-svg-icons
// npm i --save @fortawesome/pro-duotone-svg-icons
// npm i --save @fortawesome/sharp-solid-svg-icons

// ---- EXAMPLE BELOW OF IMPORTING SAME ICON BUT IN DIFFERENT STYLES ---- //
// import { faCoffee as fasCoffee } from '@fortawesome/pro-solid-svg-icons'
// import { faCoffee as farCoffee } from '@fortawesome/pro-regular-svg-icons'
// import { faCoffee as falCoffee } from '@fortawesome/pro-light-svg-icons'
// import { faCoffee as fadCoffee } from '@fortawesome/pro-duotone-svg-icons'
// import { faCoffee as fassCoffee } from '@fortawesome/sharp-solid-svg-icons'
// library.add(fasCoffee, farCoffee, falCoffee, fadCoffee, fassCoffee)

// ---- EXAMPLE HOW TO ADD DIFFERENT STYLES IN THE TEMPLATE ----- //
// <!-- Add Icons using String format -->
// <font-awesome-icon icon="fa-solid fa-coffee" />
// <font-awesome-icon icon="fa-regular fa-coffee" />
// <font-awesome-icon icon="fa-light fa-coffee" />
// <font-awesome-icon icon="fa-duotone fa-coffee" />
// <font-awesome-icon icon="fa-sharp fa-solid fa-coffee" />

// <!-- Add Icons using Array format -->
// <font-awesome-icon :icon="['fas', 'coffee']" />
// <font-awesome-icon :icon="['far', 'coffee']" />
// <font-awesome-icon :icon="['fal', 'coffee']" />
// <font-awesome-icon :icon="['fat', 'coffee']" />
// <font-awesome-icon :icon="['fad', 'coffee']" />
// <font-awesome-icon :icon="['fass', 'coffee']" />

// ------ PRO - Duotone icons  ------//
// PREFIX : 'fad'
// Example :  <font-awesome-icon :icon="['fad', 'minus-square']" />
// import { xxx } from '@fortawesome/pro-duotone-svg-icons';
// library.add(xxx);

// ------ PRO - Regular icons  ------//
// PREFIX : 'far'
// Example :  <font-awesome-icon :icon="['far', 'minus-square']" />
